module.exports = "<div class=icon-user></div> <div class=user-logged__name> <p translate=APP.YOU_ARE_LOGGED_IN></p>{{$ctrl.username()}} </div> <div class=icon-io ng-click=$ctrl.logout()></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user-logged/user-logged.template.html
// module id = 568
// module chunks = 0